import { colors, distances } from '../../../styles/constants';

import styled from 'styled-components/macro';

const StepWrapper = styled.div`
    padding-bottom: ${distances.small};
    position: relative;
    z-index: 0;

    &::before {
        content: ' ';
        position: absolute;
        width: 1px;
        background: ${colors.borderLight};
        top: 5px;
        bottom: -5px;
        left: 13px;
        z-index: -1;
    }

    &:last-child::before {
        bottom: none;
        top: none;
        height: 10px;
    }
`;

export default StepWrapper;
